import type { ConvertableUnit } from "@/libs/units";
import { buildOptions } from "./buildOptions";

// STANDARD UNIT
export const BarrelsPerDay: ConvertableUnit = {
  label: "STB/D",
  inSituLabel: "bbl/d",
  toStandardUnit: stdb => stdb,
  toThisUnit: stdb => stdb
};
export const CubicMetersPerHour: ConvertableUnit = {
  label: "m³/h",
  shortLabel: "m³/h",
  inSituLabel: "m³/h",
  toStandardUnit: m3h => m3h / 0.006624470622,
  toThisUnit: stdb => stdb * 0.006624470622
};
export const CubicMetersPerDay: ConvertableUnit = {
  label: "m³/d",
  shortLabel: "m³/d",
  inSituLabel: "m³/d",
  toStandardUnit: m3d => m3d / 0.158987294928,
  toThisUnit: stdb => stdb * 0.158987294928
};
export const ThousandCubicMetersPerDay: ConvertableUnit = {
  label: "e³m³/d",
  shortLabel: "Decs",
  inSituLabel: "Decs",
  toStandardUnit: m3d => m3d / 0.000158987294928,
  toThisUnit: stdb => stdb * 0.000158987294928
};
export const LitersPerSecond: ConvertableUnit = {
  label: "L/s",
  shortLabel: "L/s",
  inSituLabel: "L/s",
  toStandardUnit: ls => ls / 0.00184013073,
  toThisUnit: stdb => stdb * 0.00184013073
};
export const LitersPerMinute: ConvertableUnit = {
  label: "L/m",
  shortLabel: "L/m",
  inSituLabel: "L/m",
  toStandardUnit: lm => lm / 0.1104078437,
  toThisUnit: stdb => stdb * 0.1104078437
};
export const GallonsPerMinute: ConvertableUnit = {
  label: "G/m",
  shortLabel: "G/m",
  inSituLabel: "G/m",
  toStandardUnit: gm => gm / 0.0291666667,
  toThisUnit: stdb => stdb * 0.0291666667
};
export const ThousandCubicFeetPerDay: ConvertableUnit = {
  label: "mscf/d",
  shortLabel: "mscf/d",
  inSituLabel: "mscf/d",
  toStandardUnit: mscfd => mscfd / 0.005614583333333334,
  toThisUnit: stdb => stdb * 0.005614583333333334
};
export const MillionCubicFeetPerDay: ConvertableUnit = {
  label: "mmscf/d",
  shortLabel: "mmscf/d",
  inSituLabel: "mmscf/d",
  toStandardUnit: mscfd => mscfd / 0.000005614583333333334,
  toThisUnit: stdb => stdb * 0.000005614583333333334
};
export const CubicFeetPerDay: ConvertableUnit = {
  label: "scf/d",
  shortLabel: "scf/d",
  inSituLabel: "scf/d",
  toStandardUnit: scfd => scfd / 5.614583333333334,
  toThisUnit: stdb => stdb * 5.614583333333334
};
export const CubicFeetPerSecond: ConvertableUnit = {
  label: "cf/sec",
  shortLabel: "cf/sec",
  inSituLabel: "cf/sec",
  toStandardUnit: cfsec => cfsec * 15388.49722,
  toThisUnit: stdb => stdb / 15388.49722
};

export const flowRateUnitList = [
  BarrelsPerDay,
  CubicMetersPerHour,
  CubicMetersPerDay,
  LitersPerSecond,
  LitersPerMinute,
  GallonsPerMinute,
  ThousandCubicFeetPerDay,
  MillionCubicFeetPerDay,
  CubicFeetPerDay,
  CubicFeetPerSecond,
  ThousandCubicMetersPerDay
];

export const FlowRateUnits = {
  BarrelsPerDay,
  CubicMetersPerHour,
  CubicMetersPerDay,
  LitersPerSecond,
  LitersPerMinute,
  GallonsPerMinute,
  ThousandCubicFeetPerDay,
  MillionCubicFeetPerDay,
  CubicFeetPerDay,
  CubicFeetPerSecond,
  ThousandCubicMetersPerDay,
  options: buildOptions(flowRateUnitList)
};

export const liquidFlowRateUnitList = [
  BarrelsPerDay,
  CubicMetersPerHour,
  CubicMetersPerDay,
  LitersPerSecond,
  LitersPerMinute,
  GallonsPerMinute
];

export const LiquidFlowRateUnits = {
  BarrelsPerDay,
  CubicMetersPerHour,
  CubicMetersPerDay,
  LitersPerSecond,
  LitersPerMinute,
  GallonsPerMinute,
  options: buildOptions(liquidFlowRateUnitList)
};

export const gasFlowRateUnitList = [
  ThousandCubicFeetPerDay,
  MillionCubicFeetPerDay,
  CubicFeetPerDay,
  CubicFeetPerSecond,
  CubicMetersPerDay,
  ThousandCubicMetersPerDay
];

export const GasFlowRateUnits = {
  ThousandCubicFeetPerDay,
  MillionCubicFeetPerDay,
  CubicFeetPerDay,
  CubicFeetPerSecond,
  CubicMetersPerDay,
  ThousandCubicMetersPerDay,
  options: buildOptions(gasFlowRateUnitList)
};
